module.exports = __webpack_public_path__ + "img/logo-sangalli.59d1d1df.png";